import React from "react";
import { NavLink } from "reactstrap";

export enum SortDirection {
  ascending,
  descending,
}

interface SortableColumbHeaderProps {
  name: string,
  isActive: boolean,
  direction: SortDirection,
  handleSort: () => void,
}

export const SortableColumnHeader = ({ name, isActive, direction, handleSort }: SortableColumbHeaderProps) =>
  <NavLink
    className="d-inline-flex align-items-center"
    active={isActive}
    onClick={handleSort}>
    {name}
    <i className={`mx-1 ${isActive
      ? direction === SortDirection.ascending
        ? "bi-arrow-down"
        : "bi-arrow-up"
      : "bi-arrow-down-up"
      }`}
      style={{ fontSize: "0.75rem" }}
    />
  </NavLink>;
